export default __webpack_public_path__ + "static/media/phpstorm.a3608cb1.svg";